import { render, staticRenderFns } from "./CriterioNoop.vue?vue&type=template&id=263381f4"
import script from "./CriterioNoop.vue?vue&type=script&lang=js"
export * from "./CriterioNoop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports